var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8384 1.91076C19.0669 2.13922 19.1427 2.47916 19.0329 2.78305L13.6163 17.7831C13.6084 17.8048 13.5997 17.8262 13.5901 17.8472C13.487 18.072 13.3216 18.2626 13.1135 18.3961C12.9053 18.5297 12.6632 18.6007 12.4158 18.6007C12.1685 18.6007 11.9264 18.5297 11.7182 18.3961C11.515 18.2658 11.3526 18.0811 11.2491 17.8632L8.46136 12.2878L2.88592 9.50009C2.66807 9.39661 2.48342 9.23415 2.35303 9.03097C2.21945 8.82281 2.14844 8.58068 2.14844 8.33335C2.14844 8.08602 2.21945 7.84388 2.35303 7.63573C2.48661 7.42757 2.67715 7.26214 2.902 7.1591C2.923 7.14948 2.9444 7.14073 2.96613 7.13289L17.9661 1.71622C18.27 1.60648 18.6099 1.68229 18.8384 1.91076ZM10.0965 11.8312L12.3593 16.3569L16.1963 5.73142L10.0965 11.8312ZM15.0177 4.55292L4.3923 8.38988L8.91794 10.6527L15.0177 4.55292Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.a8ba8426455b03a055b9b3a60464fb80.svg";
export { ForwardRef as ReactComponent };